import InstagramPostsService from "@apps/instagram/services/InstagramPostsService";
import InstagramPostsResponseEntity from "@apps/instagram/services/InstagramPostsService/entities/InstagramPostsResponseEntity";
import { GetPostsRequestParamsDTO } from "@apps/instagram/services/InstagramPostsService/InstagramPostsService";
import InstagramPostsServiceInterface from "@apps/instagram/services/InstagramPostsService/InstagramPostsServiceInterface";
import { Observable } from "rxjs";

class InstagramPostsServiceProductPageAdapter
    implements InstagramPostsServiceInterface
{
    constructor(
        private readonly instagraPostsService: InstagramPostsService,
        private readonly productId: number
    ) {}

    getPosts(
        reqParams: GetPostsRequestParamsDTO
    ): Observable<InstagramPostsResponseEntity> {
        return this.instagraPostsService.getTaggedPosts({
            ...reqParams,
            productIds: [this.productId],
        });
    }

    loadMorePosts(
        reqParams: GetPostsRequestParamsDTO
    ): Observable<InstagramPostsResponseEntity> {
        return this.instagraPostsService.loadMoreTaggedPosts({
            ...reqParams,
            productIds: [this.productId],
        });
    }
}

export default InstagramPostsServiceProductPageAdapter;
